module.exports = __webpack_public_path__ + "static/media/logo-neteller.842757fb.svg";